import {AnyAction} from 'redux';
import {
  SET_LOAD,
  CHANGE_THEME,
  SET_ALERT,
  SET_TERMS_MODAL_VISIBLE,
  SET_PRIVACY_MODAL_VISIBLE,
} from '../actionTypes';

export interface GlobalState {
  loading?: boolean | null;
  theme?: boolean | null;
  alert?: {message: string; title: string; callback?: () => void};
  termsModalVisible: boolean;
  privacyModalVisible: boolean;
}

const initialState: GlobalState = {
  loading: false,
  theme: false,
  alert: {message: '', title: ''},
  termsModalVisible: false,
  privacyModalVisible: false,
};

const global = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_LOAD:
      return {
        ...state,
        ...action.payload,
      };
    case CHANGE_THEME:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ALERT:
      return {
        ...state,
        ...action.payload,
      };
    case SET_TERMS_MODAL_VISIBLE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_PRIVACY_MODAL_VISIBLE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {...state};
  }
};

export default global;
